import config from 'lib/config'

function logPaywall(message: string, payload: Record<string, unknown>) {
  if (!config.debug) return
  console.info('[Paywall]', message, payload)
}

/**
 * Whether paywall UI (banner / billing redirect) is enabled for this clientPid.
 */
export function canUsePaywall(userId: string | number | undefined | null): boolean {
  if (config.paywallReleased) {
    logPaywall('canUsePaywall', { released: true, granted: true, reason: 'PAYWALL_RELEASED' })
    return true
  }
  if (userId === undefined || userId === null || userId === '') {
    logPaywall('canUsePaywall', { released: false, granted: false, reason: 'NO_USER_ID' })
    return false
  }
  const uid = String(userId)
  const allowed = (config.paywallTesters ?? '')
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean)
  const granted = allowed.includes(uid)
  logPaywall('canUsePaywall', {
    released: false,
    granted,
    allowlistCount: allowed.length,
    reason: granted ? 'ALLOWLIST_MATCH' : 'ALLOWLIST_MISS',
  })
  return granted
}
